import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Icon, Text } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';

import LinkButton from '@/v2/../components/LinkButton';
import { GOOGLE_MAPS_KEY, GOOGLE_MAPS_STATIC_API_URL } from '@/v2/../config';
import useBreakpoints, { isScreen } from '@/v2/../hooks/useBreakpoints';
import usePropertyContent from '@/v2/../hooks/usePropertyContent';
import GoogleStaticMap from '@/v2/../shared/components/GoogleStaticMap';
import useSize from '@/v2/../shared/hooks/useSize';
import Map from './components/Map';

const NoWrapBox = styled(Text)`
  white-space: nowrap;
`;

const HotelLocation = React.memo(() => {
  const propertyContent = usePropertyContent();
  const breakpoints = useBreakpoints();
  const smallScreen = isScreen(breakpoints)('xs', 'sm');
  const { width, ref } = useSize();
  // setting a max width because GM returns image dimensions of 680x180
  // which gets stretched on tablets
  const maxGMWidth = width > 640 ? 640 : width;
  const mapWidth = smallScreen ? maxGMWidth : 385;
  const geo = propertyContent.geolocation;
  const center = `${geo.lat},${geo.lng}`;

  return (
    <ToggleContent
      toggle={(show) => (
        <Flex ref={ref} alignItems="center" flexDirection="column">
          <Box>
            <LinkButton onClick={show} noPadding>
              <GoogleStaticMap
                options={{}}
                alt={`Map of ${propertyContent.name}`}
                apiKey={GOOGLE_MAPS_KEY}
                url={GOOGLE_MAPS_STATIC_API_URL}
                center={center}
                width={mapWidth}
                height={180}
                zoom={15}
                markers={center}
              />
            </LinkButton>
          </Box>
          <Flex width="100%" maxWidth={mapWidth} mt={3}>
            <Icon color="text.hint" size={20} name="place" mr={2} />
            <Text mr="2" lineHeight="20px" color="text.body" fontSize="xs">
              {propertyContent.address}
            </Text>
            <NoWrapBox ml="auto">
              <LinkButton onClick={show} noVerticalPadding>
                <Text fontSize="sm" lineHeight={1.5} fontWeight="700">
                  View map
                </Text>
              </LinkButton>
            </NoWrapBox>
          </Flex>
        </Flex>
      )}
      // TS just struggling with the `Function` type from js file
      // @ts-ignore
      content={(hide) => <Map onClose={hide} />}
    />
  );
});

export default HotelLocation;
